/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class CodeGroup {
        public groupName: string;
        public codes: ApplicationCode[];
    }
}